import { Component, Inject, OnInit } from '@angular/core';
import { Utils } from '../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { CreateExcellenceFactorPopupComponent } from './createexcellencefactor-popup/createexcellencefactor-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { Router } from '@angular/router';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';
import { GroupFunctionRows } from '../group-function-rows';
import { ItemSelection } from '../item-selection';

@Component({
    selector: 'excellence-factor',
    templateUrl: './excellence-factor.component.html',
    styleUrls: ['./excellence-factor.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class ExcellenceFactorComponent implements OnInit {

    subscriptions: any[] = [];
    readonly groups = new GroupFunctionRows<ExcellenceFactor>(visibleItems => this.selection.retain(visibleItems));
    columnsToDisplay = ['Name', 'Description', 'ExcellenceLever', 'actions', 'ChangeLog'];

    isRemoveActive = false;
    readonly selection = new ItemSelection<ExcellenceFactor>(item => item.ExcellenceFactorId);
    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private toastrService: ToastrService
        , private router: Router
        , private customDialog: CustomDialogService
        , public defaults: DefaultValuesService
    ) { }

    ngOnInit(): void {
        // Just once to get user role in case of loading directly that component.
        // Remove actions item from columnsToDisplay
        if (!this.defaults.isMersyAdminBranchExcellenceUser)
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        this.getExcellenceFactors();
    }

    getExcellenceFactors() {
        Utils.httpGetExcellenceFactors(
            this.http,
            this.baseUrl,
            this,
            function (tthis: ExcellenceFactorComponent, list: ExcellenceFactor[]) {
                tthis.groups.setItems(list);
            },
            null
        )
    }

    onRemoveExcellenceFactor(element: ExcellenceFactor) {
        this.customDialog.openConfirm({
            title: "Delete Excellence Factor",
            message: `Do you want to ${element.Name} - (${element.Description})?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpDeleteExcellenceFactor(
                    this.http
                    , this.baseUrl
                    , element.ExcellenceFactorId
                    , this
                    , function (tthis: ExcellenceFactorComponent, result: any) {
                        if (result) {
                            tthis.getExcellenceFactors();
                            tthis.toastrService.success(`Excellence Factor was deleted successfully!`);
                        }
                        else
                            tthis.toastrService.error(`Excellence factor could not be deleted. Please, contact with administrator`);
                    },
                    function (tthis: ExcellenceFactorComponent, result: any) {
                        tthis.toastrService.error('Excellence factor assigned to a wave. If not, please, contact with administrator');
                    }
                );
            }
        });
    }

    onEditExcellenceFactor(element: ExcellenceFactor) {
        const dialog = this.dialogForm.open(CreateExcellenceFactorPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect', 'excellence-factor-dialog'],
            minWidth: '700px',
            disableClose: true,
            data: element,
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceFactors()
        })
    }

    openCreateExcellenceFactorPopup() {
        const dialog = this.dialogForm.open(CreateExcellenceFactorPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect', 'excellence-factor-dialog'],
            minWidth: '700px',
            disableClose: true,
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceFactors()
        })
    }

    onClickDownload() {
        Utils.httpDownloadExcellenceFactors(
            this.http,
            this.baseUrl,
            `Excellence Factor`,
            'factor');
    }

    onClickUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadExcellenceFactor()]);
    }
    onClickTranslDownload() {
        Utils.httpDownloadExcellenceFactorsTransl(
            this.http,
            this.baseUrl,
            `ExcellenceFactorTransl`,
            'Factor');
    }

    onClickTranslUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadTranslFactor()]);
    }

    onHistoryDetail(element: ExcellenceFactor, type: string) {

        var excellenceFactorId = 0;

        if (element.ExcellenceFactorId != undefined)
            excellenceFactorId = element.ExcellenceFactorId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: excellenceFactorId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }

    public toggleRemoveFactor() {
        this.setRemoveMode(!this.isRemoveActive);
    }

    private setRemoveMode(active: boolean) {
        this.isRemoveActive = active;
        this.selection.clear();
    }

    onClickBulkRemove() {
        const ids = this.selection.ids;
        this.customDialog.openConfirm({
            title: "Remove selected Factors",
            message: `Do you want to remove ${ids.length} selected Factors? Please note that action cannot be rollbacked!`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpDeleteExcellenceFactors(
                    this.http
                    , this.baseUrl
                    , ids
                    , this
                    , function (tthis: ExcellenceFactorComponent) {
                        tthis.toastrService.success('Excellence Factors were removed successfully!');
                        tthis.setRemoveMode(false);
                        tthis.getExcellenceFactors();
                    },
                    function (tthis: ExcellenceFactorComponent) {
                        tthis.toastrService.error('Excellence Factors could not be removed. Please, contact with administrator');
                    }
                );
            }
        })
    }
}
